module.exports = __webpack_public_path__ + "img/know-how.e417cb55.svg";